import { ActionType } from 'typesafe-actions';

import * as checkoutActions from 'store/actions/checkout';
import { call, put, takeLeading } from 'redux-saga/effects';
import { rejectPromiseAction, resolvePromiseAction } from 'redux-saga-promise-actions';
import Endpoints from 'endpoints';
import GipsyyGDSApi from 'apis/GipsyGDS';
import { CheckoutResponse } from 'store/types';

function* makePaymentBR(action: ActionType<typeof checkoutActions.makePaymentBR.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: CheckoutResponse } = yield GipsyyGDSApi.post(
      Endpoints.makePaymentPinpad,
      {
        ...action.payload,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    yield put(checkoutActions.makePaymentBR.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(checkoutActions.makePaymentBR.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* getInfoBpe(action: ActionType<typeof checkoutActions.getInfoBpe.request>) {
  const { paymentID } = action.payload;

  try {
    const response: { data: any } = yield GipsyyGDSApi.get(Endpoints.getInfoBpe(paymentID));

    yield put(checkoutActions.getInfoBpe.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(checkoutActions.getInfoBpe.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

function* createPaymentLink(action: ActionType<typeof checkoutActions.createPaymentLink.request>) {
  const authData: any = localStorage.getItem('authAgencyData');
  const { token } = JSON.parse(authData);
  try {
    const response: { data: CheckoutResponse } = yield GipsyyGDSApi.post(
      Endpoints.createPaymentLink,
      {
        ...action.payload,
      },
      {
        headers: {
          auth: token,
        },
      },
    );

    yield put(checkoutActions.createPaymentLink.success(response.data));
    yield call(resolvePromiseAction, action, response.data);
  } catch (error) {
    yield put(checkoutActions.createPaymentLink.failure());
    yield call(rejectPromiseAction, action, error);
  }
}

export const watchCheckout = [
  takeLeading(checkoutActions.makePaymentBR.request, makePaymentBR),
  takeLeading(checkoutActions.getInfoBpe.request, getInfoBpe),
  takeLeading(checkoutActions.createPaymentLink.request, createPaymentLink),
];
